<main-navi>
    <div>
        <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
        <div id="offcanvas_menu" class="relative z-50 lg:hidden { (!state.transitioning && !state.sidebar_visible) ? 'hidden' : '' }" role="dialog" aria-modal="true" ontransitionend="{ handleTransitionEnd }">
            <div class="fixed inset-0 bg-gray-900/80 transition-opacity ease-linear duration-300 { state.sidebar_visible ? 'opacity-100' : 'opacity-0' }"></div>
            <div class="fixed inset-0 flex">
                <div class="relative mr-16 flex w-full max-w-xs flex-1 transition ease-in-out duration-300 transform { state.sidebar_visible ? 'translate-x-0' : '-translate-x-full' }">
                    <div class="absolute left-full top-0 flex w-16 justify-center pt-5 ease-in-out duration-300 { state.sidebar_visible ? 'opacity-100' : 'opacity-0' }">
                        <button type="button" class="-m-2.5 p-2.5" onclick="{
                                    toggle_sidebar
                                }">
                            <span class="sr-only">{ state.sidebar_visible ? 'Chiudi' : 'Apri' } sidebar</span>
                            <svg class="size-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <!-- Sidebar component, swap this element with another sidebar if you like -->
                    <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-cyan-600 px-6 pb-2">
                        <div class="flex h-16 shrink-0 items-center">
                            <img class="h-8 w-auto" src="/images/logo.png" alt="NSG + NokNok">
                        </div>
                        <nav class="flex flex-1 flex-col">
                            <ul role="list" class="flex flex-1 flex-col gap-y-7">
                                <li>
                                    <ul role="list" class="-mx-2 space-y-1">
                                        <li each="{ item in item_navs }" onclick="{
                                                    handleCloseSidebar
                                                }">
                                        <item-nav id="{ item.id }" title="{ item.title }" link="{ item.link }"></item-nav>
                                </li>
                                <li><logout-button /></li>
                            </ul>
                            </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <!-- Static sidebar for desktop -->
        <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-cyan-600 px-6 pb-4">
                <div class="flex h-16 shrink-0 items-center">
                    <img class="h-8 w-auto" src="/images/logo.png" alt="NSG + NokNok">
                </div>
                <nav class="flex flex-1 flex-col">
                    <div class="flex flex-1 flex-col gap-y-7 justify-between">
                        <ul role="list" class="flex flex-1 flex-col gap-y-7">
                            <li>
                                <ul role="list" class="-mx-2 space-y-1">
                                    <li each="{ item in state.item_navs }">
                                    <item-nav id="{ item.id }" title="{ item.title }" link="{ item.link }"></item-nav>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <li>
                            <ul role="list" class="-mx-2 space-y-1 pb-2">
                                <li><logout-button /></li>
                            </ul>
                        </li>
                    </div>
                </nav>
            </div>
        </div>

        <div class="sticky top-0 z-40 flex items-center gap-x-6 bg-cyan-600 px-4 py-4 shadow-xs sm:px-6 lg:hidden">
            <button type="button" class="-m-2.5 p-2.5 text-cyan-200 lg:hidden" onclick="{
                        toggle_sidebar
                    }">
                <span class="sr-only">{ state.sidebar_visible ? 'Chiudi' : 'Apri' } sidebar</span>
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
            </button>
            <div class="flex-1 text-sm font-semibold leading-6 text-white">Dashboard</div>
        </div>
    </div>

    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { KEYS } from '/src/utils/constants'
        export default {

            onBeforeMount(props, state) {
                this.state = {
                    sidebar_visible: false,
                    panel_hidden: true,
                    current_item: null,
                    user: StoreService.getUser(),
                    item_navs: []
                }
            },

            async onMounted(props, state) {
                this.updateMenu()
            },

            toggle_sidebar() {
                this.update({
                    transitioning: true,
                    sidebar_visible: !this.state.sidebar_visible
                })
            },

            handleCloseSidebar() {
                this.update({
                    transitioning: true,
                    sidebar_visible: false
                })
            },

            handleTransitionEnd(e) {
                if (!this.state.sidebar_visible) {
                    this.update({
                        transitioning: false
                    })
                }
            },

            updateMenu() {
                // Menu di base
                const baseMenu = [
                    {
                        id: KEYS.COMMESSE,
                        title: 'Commesse',
                        link: '#/commesse'
                    },
                    {
                        id: KEYS.TASK,
                        title: 'Tasks',
                        link: '#/tasks'
                    }
                ];

                // Aggiorna lo stato
                this.update({item_navs: baseMenu});
            }
        }
    </script>
</main-navi>
